import { createReducer, on, Action } from '@ngrx/store';
import { changeCategoryCode, saveCanalOrigin } from '../actions/utilData.action';

export const initialState = {
  categoryCode: 0,
  canal: "APP_PERSONAS"
};

export interface IUtilDataState {
  categoryCode: number;
  canal: string;
}

const utilData = createReducer(
  initialState,
  on(changeCategoryCode, (_state, {categoryCode})=> {
    return {
      ..._state,
      categoryCode: categoryCode
    };
  }),
  on(saveCanalOrigin, (_state, {canal}) => {
    return {
      ..._state,
      canal: canal
    };
  })
);

export function utilDataReducer(state: IUtilDataState, action: Action) {
  return utilData(state, action);
}
